import { password, required, strongAdminPassword } from "utils/validate.util";
import InputRedux from "components/molecules/InputRedux";
import { ReduxFormField } from "components/molecules/ReduxFormFields";

export const forceChangePasswordFields: ReduxFormField[] = [
  {
    name: "current_password",
    label: "Current password",
    validate: [required],
    component: InputRedux,
    cellProps: { lg: 12 },
    InputProps: { showIcon: true, type: "password" },
  },
  {
    name: "password",
    label: "New password",
    validate: [required, strongAdminPassword, password],
    component: InputRedux,
    cellProps: { lg: 12 },
    InputProps: { showIcon: true, type: "password" },
  },
  {
    name: "confirm_password",
    label: "Confirm new password",
    validate: [required, password],
    component: InputRedux,
    cellProps: { lg: 12 },
    InputProps: { showIcon: true, type: "password" },
  },
];
